import { render, staticRenderFns } from "./codeDictDrawer.vue?vue&type=template&id=a5ba7f1c&scoped=true"
import script from "./codeDictDrawer.vue?vue&type=script&lang=js"
export * from "./codeDictDrawer.vue?vue&type=script&lang=js"
import style0 from "./codeDictDrawer.vue?vue&type=style&index=0&id=a5ba7f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ba7f1c",
  null
  
)

export default component.exports